// extracted by mini-css-extract-plugin
export default {"joinInnerContainer":"WivaTemplateConfig_joinInnerContainer__Ryi8L"};